
import { serializeAudioBuffer } from './audio-helper.ts';
import { EncoderWorkerRes } from './types.ts';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/order
import Worker from 'worker-loader!./worker.ts';

const worker = new Worker();
export default function encode(audioBuffer: AudioBuffer, type: string): Promise<Blob> {
  const id = Math.random();

  return new Promise((resolve, reject) => {
    const audioData = serializeAudioBuffer(audioBuffer);
    worker.postMessage({
      type,
      audioData,
      id,
    });
    
    const listener = ({ data }: MessageEvent<EncoderWorkerRes>) => {
      if (!data || data.id !== id) return;
      if (data.success) {
        resolve(data.data);
      } else {
        reject(new Error(data.message));
      }

      worker.removeEventListener('message', listener);
    };

    worker.addEventListener('message', listener);
  });
}
